<template>
    <div>
        
    </div>
</template>

<script>
export default {
    name: 'EticketPublicTickets',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>